module.exports = __webpack_public_path__ + "img/video-poster.41c4274b.jpeg";